var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828h161.839v335.448z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M170.67 88.277h170.67v335.45H170.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 0 1 512 97.101v317.792a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#41479b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.62 207.253s-24.564 0-42.987 18.423h12.281s-11.898 21.493-18.039 58.339l-12.665-2.068v-56.454l12.281 4.021-21.492-52.965-21.493 52.965 12.281-4.095v56.527l-12.665 2.068c-6.141-36.845-18.039-58.339-18.039-58.339h12.281c-18.422-18.422-42.986-18.422-42.986-18.422 30.704 36.845 30.704 98.255 30.704 98.255l30.704-5.117v41.963h18.423v-41.963l30.704 5.117c.002.001.002-61.408 30.707-98.255z",
    fill: "#464655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBb);
export default __webpack_public_path__ + "static/media/bb.18f5f70d388cb0cd3fc71bf19b256521.svg";
export { ForwardRef as ReactComponent };